import { Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { FooterComponent } from "../../layout/footer/footer.component";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-pro',
  standalone: true,
  templateUrl: './pro.component.html',
  styleUrl: './pro.component.scss',
  imports: [HeaderComponent, FooterComponent, RouterLink]
})
export class ProComponent {
  downloadFile(fileName: string) {
    const link = document.createElement('a');
    link.href = `assets/spruce-pro/${fileName}`;
    link.download = fileName;
    link.click();
  }
}
